import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { Switch } from "../components/ui/switch"
import { cn } from "../lib/utils"

export function SwitchRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()
  const text = element.text ? String(resolveSymbol(element.text) ?? "") : undefined

  const handleCheckedChange = (value: boolean) => {
    dispatchEvent(element.id, "change", { value })
  }

  return (
    <div className={cn("flex items-center space-x-2", element.className)} data-testid={`switch-${element.id}`}>
      <Switch id={element.id} onCheckedChange={handleCheckedChange} />
      {text && <label htmlFor={element.id} className="text-sm font-medium leading-none">{text}</label>}
    </div>
  )
}
